<div class="pricing-5 section-gray pt-2 mt-3">
  <div class="container" id="ref_pack">

    <div class="row">
      <div class="col-md-6 ml-auto mr-auto text-center">
        <h2 class="title font-weight-bold">Our Packages</h2>
        <h5 class="description">Choose a plan that suits your Practice needs the best:</h5>
      </div>
    </div>

    <div class="row">

      <div class="col-md-12">
        <div class="choose-plan">
          <!-- <div class="nav-tabs-navigation">
                      <div class="nav-tabs-wrapper"> -->
          <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab1" type="pills"
            class="nav-pills-danger justify-content-center">
            <li class="nav-item" [ngbNavItem]="1">
              <a class="nav-link" ngbNavLink> Packages</a>
              <ng-template ngbNavContent>
                <div class="space-top"></div>
                <div class="row">
                  <div class="col-md-3 mb-3">
                    <a [routerLink]="['/packages/diy-starter']">
                      <div class="card card-package h-100 mb-3" data-color="default">
                        <div class="card-body">
                          <h4 class="card-category text-primary"></h4>

                          <h3 class="card-title align-items-left text-primary mb-2">DIY Starter</h3>
                          <p>Ideal for small startup Practices.</p>
                          <small>
                            <ul class="text-left text-sm">


                              <li>
                                <h3 class="card-category"><strong></strong>Practice</h3>
                              </li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Patient file and claim capturing.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Billing and submission of claims.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Medical aids follow-ups.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Claims and Medical Aid Debt
                                reconciliation.</li>

                            </ul>
                          </small>

                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-3  mb-3">





                    <a [routerLink]="['/packages/diy']">
                      <div class="card card-package h-100 mb-3">
                        <div class="card-body">
                          <h4 class="card-category text-primary"></h4>

                          <h3 class="card-title text-primary mb-2">DIY</h3>

                          <p>Ideal for Healthcare Providers who want to manage their own practice.</p>
                          <small>
                            <ul class="text-left">



                              <li>
                                <h3 class="card-category"><strong></strong>Practice</h3>
                              </li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Patient file and claim capturing.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Billing and submission of claims.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Medical aids follow-ups.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Claims and Medical Aid Debt
                                reconciliation.</li>
                            </ul>
                          </small>
                        </div>

                      </div>
                    </a>
                  </div>

                  <div class="col-md-3  mb-3">
                    <a [routerLink]="['/packages/full-house']">
                      <div class="card card-package h-100 mb-3">
                        <div class="card-body">
                          <h4 class="card-category text-success"><strong></strong></h4>

                          <h3 class="card-title text-primary mb-2">Full House</h3>
                          <p class="font-size-small">Ideal for Healthcare Providers who want assistance with managing
                            their practice.</p>
                          <small>
                            <ul class="text-left">
                              <li>
                                <h3 class="card-category"><strong></strong>Practice</h3>
                              </li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Patient file and claim capturing.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Billing and submission of claims.</li>
                              <li>
                                <h3 class="card-category"><strong></strong>eMD</h3>
                              </li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Medical aids follow-ups.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Claims and Medical Aid Debt
                                reconciliation.</li>
                            </ul>
                          </small>

                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-3  mb-3">
                    <a [routerLink]="['/packages/e-buro']">
                      <div class="card card-package h-100 mb-3" data-color="default">
                        <div class="card-body">
                          <h4 class="card-category text-success"></h4>

                          <h3 class="card-title text-start mb-2">e-Buro</h3>
                          <p>Ideal for Healthcare Providers who want comprehensive Bureau services.</p>

                          <small>
                            <ul class="text-left">

                              <li>
                                <h3 class="card-category"><strong></strong>eMD</h3>
                              </li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Patient file and claim capturing.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Billing and submission of claims.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Medical aids follow-ups.</li>
                              <li><i class="fa fa-check" aria-hidden="true"></i>Claims and Medical Aid Debt
                                reconciliation.</li>
                            </ul>
                          </small>


                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </ng-template>
            </li>
            <li class="nav-item" [ngbNavItem]="2">
              <a class="nav-link" ngbNavLink> Value Added Services</a>
              <ng-template ngbNavContent>
                <div class="space-top"></div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="card card-pricing ">
                      <div class="card-body">
                        <h6 class="card-category text-warning">Whats included with all packages</h6>
                        <ul class="text-left">
                          <li>e-AI: AI-powered precision for diagnosis and treatment decisions</li>
                          <li>Benefit Check</li>
                          <li>Bulk SMS</li>
                          <li>Calendar Appointments</li>
                          <li>Clinical Notes </li>
                          <li>Cloud Application </li>
                          <li>Comprehensive Clinical Notes</li>
                          <li>Electronic Data Interchange (EDI)</li>
                          <li>Electronic Medical Records</li>
                          <li>Electronic Patient File Management</li>
                          <li>Electronic Remittance Advice</li>
                          <li>Electronic Switching </li>
                          <li>eScript: Electronic Prescriptions</li>
                          <li>Free Rates Updates</li>
                          <li>Graphically Represented Clinical Results</li>
                          <li>Healthcare Advisory </li>
                          <li>Healthcare IT Consulting </li>
                          <li>Medical Billing</li>
                          <li>Medical Debt Management </li>
                          <li>Member Validation</li>
                          <li>Mobile Web App</li>
                          <li>Paediatric Graphs </li>
                          <li>Paperless Solution </li>
                          <li>Pathology Results </li>
                          <li>Patient Clinical Records</li>
                          <li>Patient Debt Recovery </li>
                          <li>Patient Family Check</li>
                          <li>Practice Management Application</li>
                          <li>Real-time Benefit Checks</li>
                          <li>Real-time Claims</li>
                          <li>Real-Time Claims Submission</li>
                          <li>Real-time Pathology Results Graphed</li>
                          <li>Tariff Coding and Pricing</li>
                          <li>Training Services </li>
                          <li>Virtual Consultations</li>


                        </ul>




                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card card-pricing ">
                      <div class="card-body">
                        <h6 class="card-category text-warning">Whats included with all packages</h6>


                        <ul>
                          <li>Training Services</li>
                          <li>Support</li>
                          <li>Healthcare Advisory</li>
                          <li>doctorsnearme®</li>
                          <li>Online Calendar</li>
                          <li>Virtual Consultations</li>
                          <li>POPIA Complaint</li>
                          <li>Cloud Application</li>
                          <li>Electronic Remittance Advice (ERA)</li>

                        </ul>

                        <h6 class="card-category text-warning">Additional Services</h6>

                        <ul>
                          <ul>
                            <li>Patient Debt Recovery</li>
                          </ul>

                        </ul>

                      </div>
                    </div>
                  </div>
              


                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
          <!-- </div>
                  </div> -->
        </div>
      </div>


    </div>
  </div>
</div>



<div class="container mt-n1 justify-content-center"
  style="z-index: 900; position: absolute; left: 50%; transform: translateX(-50%);">
  <div class="row mt-n5 pb-4 p-3 mx-sm-0 mx-1 position-relative justify-content-center">


    <div class="col-lg-8 mt-lg-n2 mt-2">
      <label class="">&nbsp;</label>
      <button type="button" class="btn btn-sm btn-danger w-100 mb-0" [routerLink]="['/get-a-quote']"> Get A Quote
      </button>
    </div>
  </div>
</div>